import React from "react";
import type { ResizeCallbackData } from "react-resizable";
import { Resizable } from "react-resizable";

export default function ResizableTitle(props: Readonly<React.HTMLAttributes<any> & IResizableTitlePropsType>) {
    const { onResizeStop, width, ...restProps } = props;
    const [internalWidth, setInternalWidth] = React.useState<number>(width);

    const handleResize = React.useCallback((e: React.SyntheticEvent<Element>, data: ResizeCallbackData) => {
        setInternalWidth(data.size.width);
    }, []);

    const handleResizeStop = React.useCallback(
        (e: React.SyntheticEvent<Element>, data: ResizeCallbackData) => {
            setInternalWidth(data.size.width);
            onResizeStop(e, data);
        },
        [onResizeStop],
    );

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable
            width={internalWidth}
            height={0}
            handle={<span className="react-resizable-handle" onClick={(e) => e.stopPropagation()} />}
            onResize={handleResize}
            onResizeStop={handleResizeStop}
            axis="x"
            draggableOpts={{
                enableUserSelectHack: true,
            }}
        >
            <th {...restProps} className="select-none text-nowrap" />
        </Resizable>
    );
}
